/*global _moovilaSecurity, TTLoginTypeEnum, TTSessionStatusEnum, GetAppInfo, TTApplicationEnum */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import cx from 'classnames';
import validator from 'validator';
import { Route, Switch, Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { login, logout, resetPassword, clearPasswordReset } from '../../actions';
import resetPasswordConstants from '../../constants/resetPassword';

import { QuestionBox, MessageBox, v2Api } from 'moovila-common';
import $ from 'webpack-zepto';

class NavLoggedIn extends Component {
    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(e) {
        e.preventDefault();
        this.props.logout();
    }

    render() {
        const loggedIn = this.props.loggedIn;
        return (
            <nav className="Header__Nav masthead-login">
                <div className="masthead-logout text-right" style={{ display: 'block', marginTop: '0' }}>
                    <div className="enterprise-name">MOOVILA, Inc</div>
                    <Link to="/login" className="email-label" onClick={this.handleLogout}>
                        <span style={{ color: '#4b52b5', fontWeight: 700 }}>Logout: </span>
                        {loggedIn.login}
                    </Link>
                </div>
            </nav>
        );
    }
}

const initialNavLoggedOutState = {
    username: '',
    password: '',
    showReset: false,
    message: null,
    loginStage: 0,
    inputDisabled: false,
    redirect: false,
    pollTimeout: null,
};

class NavLoggedOut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialNavLoggedOutState,
        };

        this.passwordInput = React.createRef();

        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.resetLogin = this.resetLogin.bind(this);
        this.clearPasswordReset = this.clearPasswordReset.bind(this);
        this.resetPasswordHandler = this.resetPasswordHandler.bind(this);
        this.pollSessionStatus = this.pollSessionStatus.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.resetPasswordNow) {
            this.resetPassword();
        }
    }

    resetPassword() {
        if (!this.state.username.length || !validator.isEmail(this.state.username)) {
            this.setState({ message: 'Please enter a valid email address' })
            return;
        }
        this.setState({ showReset: true });
    }

    resetLogin() {
        this.setState({ ...initialNavLoggedOutState });
    }

    resetPasswordHandler(e) {
        const { username } = this.state;
        this.setState({ showReset: false, message: false });
        if (username.length) { // && isEmail this.state.email - validate
            this.props.resetPassword(username);
        }
    }

    clearPasswordReset(e) {
        e.preventDefault();
        this.setState({ showReset: false, message: false });
        this.props.clearPasswordReset();
    }

    handleUsernameChange(event) {
        this.setState({ username: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    pollSessionStatus(sessionGUID) {
        v2Api
            .fetch('Security/CheckSessionStatus', { sessionGUID })
            .then(({ data, info, header }) => {
                if (data.sessionStatusCode === TTSessionStatusEnum.SS_AUTHENTICATED) {
                    clearTimeout(this.state.pollTimeout);
                    _moovilaSecurity.BuildSessionInfo(sessionGUID, header.UserGUID, header.EnterpriseGUID, () => this.setState({ redirect: true }));
                } else if (data.sessionStatusCode === TTSessionStatusEnum.SS_PENDING_AUTHENTICATION) {
                    this.setState({ pollTimeout: setTimeout(() => this.pollSessionStatus(sessionGUID), 250) });
                } else {
                    this.setState({ ...initialNavLoggedOutState })
                }
            });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.inputDisabled) {
            return;
        }
        if (this.state.loginStage === 0 && this.state.username.length) {
            const windowHandle = window.open(null, '_blank', 'width=100,height=100,titlebar=0');
            this.setState({
                inputDisabled: true,
            });

            GetAppInfo(TTApplicationEnum.MOOVILA, (appInfo) => {
                this.getLoginType({
                    emailAddress: this.state.username,
                    isMobile: false,
                    userEnvironment: navigator.userAgent,
                    uuid: 'web',
                    clientVersion: 'mom',
                    /// 5 = MOM 
                    originClientApp: 5,
                    language: 'en',
                    isSelfRegistration: false
                },
                    (data) => {
                        if (data.loginTypeCode === TTLoginTypeEnum.LT_SAML) {
                            const samlUrl = data.samlUrl;
                            const sessionGUID = data.sessionGUID;

                            const w = 600;
                            const h = 800;
                            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
                            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

                            const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
                            const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

                            const left = ((width / 2) - (w / 2)) + dualScreenLeft;
                            const top = ((height / 2) - (h / 2)) + dualScreenTop;

                            windowHandle.resizeTo(w, h);
                            windowHandle.moveTo(left, top);
                            windowHandle.location.replace(samlUrl);

                            this.pollSessionStatus(sessionGUID);
                        }
                        else {
                            this.setState({
                                loginStage: 1,
                                password: '',
                                inputDisabled: false,
                            });
                            this.passwordInput.current.focus();
                            windowHandle.close();
                        }
                    }

                );

            });

            v2Api
                .fetch('Security/GetLoginType', {
                    userEmailAddress: this.state.username,
                    requireAdmin: true,
                })
                .then();
            return;
        }
        if (this.state.loginStage === 1 && this.state.password.length) {
            this.props.login(this.state.username, this.state.password);
            return;
        }
        if (!this.state.username) {
            this.setState({
                message: 'Please enter a valid email address.',
            });
            return;
        }
        if (!this.state.password) {
            this.setState({
                message: 'Please enter your password.',
            });
        }
    }


    getLoginType(params, callback) {

        GetAppInfo(TTApplicationEnum.API, function (appInfo) {

            var url = appInfo.siteURL + '/Security/v3/GetLoginType';
            var jsonData = JSON.stringify(params);

            $.ajax({
                url: url,
                type: 'POST',
                contentType: 'application/json',
                data: jsonData,
                success: callback,
                error: function (xhr, textStatus, errorThrown) {

                    try {
                        var err = JSON.parse(xhr.responseText);
                        console.error(err);
                    }
                    catch (err) {
                        console.error('API GET call failed with invalid json: ' + xhr.responseText);
                    }

                }
            });
        });

    }


    render() {
        if (this.state.redirect) {
            return <Redirect to='/' />;
        }
        let resetDialog = null;
        let enterUsernameMessage = null;

        if (this.state.showReset) {
            resetDialog = (
                <QuestionBox
                    title='Reset Password?'
                    backTo='/login'
                    yesText='Reset'
                    yesCallback={this.resetPasswordHandler}
                    noCallback={this.clearPasswordReset}
                >
                    Click "Reset" below to reset your password.  An email will be sent providing instructions on how to create a new password.
                </QuestionBox>
            );
        }

        if (this.state.message) {
            enterUsernameMessage = <MessageBox
                title='Invalid Entry'
                callback={this.clearPasswordReset}
            >{this.state.message}</MessageBox>
        }

        let forgotMessage;
        let forgotAlert = null;
        switch (this.props.forgotStatus) {
            case resetPasswordConstants.USER_NOT_VALIDATED:
                forgotMessage = 'Account not validated||You must first verify your email address, by clicking the link in the email you received.';
                break;
            case resetPasswordConstants.PASSWORD_NOT_RESET:
                forgotMessage = 'Invalid Email Address||You have entered an invalid email address.  Please re-enter.';
                break;
            case resetPasswordConstants.PASSWORD_SUCCESSFULLY_RESET:
                forgotMessage = 'Password Reset||Password reset instructions have been sent to the email address you provided.';
                break;
            default:
                forgotMessage = null;
        }

        if (forgotMessage) {
            const title = forgotMessage.split('||')[0];
            const body = forgotMessage.split('||')[1];
            forgotAlert = <MessageBox
                title={title}
                callback={this.clearPasswordReset}
            >{body}</MessageBox>
        }

        return (
            <nav className="Header__Nav masthead-login" style={{ height: 93, width: 400 }}>
                {this.state.loginStage === 0 ?
                    <div style={{ float: 'right', width: '100%' }}>
                        <form className="form-inline" onSubmit={this.handleSubmit}>
                            <div className="form-group" style={{ width: 'calc(100% - 81px)' }}>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Email"
                                    style={{ width: '100%' }}
                                    value={this.state.username}
                                    disabled={this.state.inputDisabled}
                                    onChange={this.handleUsernameChange} />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ width: 72, float: 'right' }}
                                disabled={this.state.inputDisabled}
                            >
                                Next
                            </button>
                        </form>
                        <div className="forgot-password" style={{ marginRight: 0 }}>
                            {this.state.inputDisabled ?
                                <span className="btn btn-link" onClick={this.resetLogin}>
                                    Cancel
                                </span>
                                :
                                null
                            }
                        </div>
                    </div>
                    :
                    <div style={{ float: 'right', width: '100%' }}>
                        <form className="form-inline" onSubmit={this.handleSubmit}>
                            <div className="form-group" style={{ width: 'calc(100% - 81px)' }}>
                                <input
                                    ref={this.passwordInput}
                                    type="password"
                                    className="form-control"
                                    placeholder="Password"
                                    style={{ width: '100%' }}
                                    value={this.state.password}
                                    onChange={this.handlePasswordChange} />
                            </div>
                            <button type="submit" className="btn btn-primary" style={{ width: 72, float: 'right' }}>
                                Login
                            </button>
                        </form>
                        <div className="forgot-password" style={{ marginRight: 0, whiteSpace: 'nowrap' }}>
                            <span className='ellipsis' style={{ display: 'inline-block', maxWidth: 483, color: '#000', marginRight: 9 }}>{this.state.username}</span>
                            <span className="btn btn-link" onClick={this.resetPassword} style={{ position: 'relative', top: 7 }}>
                                Forgot password?
                            </span>
                            <span className="btn btn-link" onClick={this.resetLogin} style={{ position: 'relative', top: 7, marginLeft: 6 }}>
                                Cancel
                            </span>
                        </div>
                    </div>
                }
                {resetDialog}
                {enterUsernameMessage}
                {forgotAlert}
            </nav>
        );
    }
}

const Logo = ({ small }) => {
    const logoClass = cx({
        'masthead-brand': true,
        'masthead-brand--small': small
    });
    return (
        <div className={logoClass}>
            Moovila Enterprise Console
        </div>
    );
}

// move this to its own file
const PageHeader = ({ title, icon, backTo, backText }) => (
    <div className="row">
        <div className="header-block header-block--ec ECHeader_hasMargin col-xs-12 vision-skin-rev">
            <div className="inner">
                <div className="row">
                    <div className="col-xs-3 ECHeader_btnBack">
                        <Link to={backTo} className="btn btn-block back">
                            <i className="fa fa-chevron-left fa-1x back-icon pull-left"></i>
                            <span className="back-text ECHeader_lblBackText">{backText}</span>
                        </Link>
                    </div>
                    <div className="col-xs-6 header-title ellipsis">
                        <i className={`fa ${icon} pad-right`} aria-hidden="true"></i>
                        <span className="title-text ECHeader_lblHeader">{title}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const Masthead = ({
    loggedIn,
    login,
    logout,
    resetPassword,
    clearPasswordReset,
    forgotStatus,
    title,
    icon,
    location,
    backTo = '/home',
    backText = 'Back to home',
}) => {
    const mastheadClass = cx({
        'masthead clearfix': true,
        'masthead--sm': location.pathname !== '/home'
    })
    return (
        <div className={mastheadClass}>
            <div className="row">
                <div className="col-xs-12">
                    <div className="inner">
                        <Switch>
                            <Route path="/:path(admin|utilities)" render={() => <Logo small={true} />} />
                            <Route render={() => <Logo />} />
                        </Switch>
                        <Switch>
                            <Route path="/:path(home|admin|utilities)" render={() => <NavLoggedIn loggedIn={loggedIn} logout={logout} />} />
                            <Route render={() =>
                                <NavLoggedOut
                                    login={login}
                                    resetPassword={resetPassword}
                                    forgotStatus={forgotStatus}
                                    clearPasswordReset={clearPasswordReset}
                                />} />
                        </Switch>
                    </div>
                    <Route
                        path="/:path(admin|utilities)"
                        render={() => <PageHeader title={title} icon={icon} backTo={backTo} backText={backText} />} />
                </div>
            </div>
        </div>
    );
}

export default withRouter(connect(state => state, {
    login,
    logout,
    resetPassword,
    clearPasswordReset,
})(Masthead));



// WEBPACK FOOTER //
// ./src/components/Masthead/Masthead.js